import { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function CheckLogin(){
const navigation = useNavigate()
  
const successfulLogin = async() =>{
  try{
    await axios.get(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/login/success`,{withCredentials:true})
  return(
    navigation("/")
  )
   
      
  }catch(e){
    return( navigation("/"))
  
  }
}

useEffect(()=>{
  successfulLogin()
// eslint-disable-next-line react-hooks/exhaustive-deps
},[])

 
}

export default CheckLogin;